import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { get, isEmpty } from 'lodash';
import { RootState } from 'modules';
import queryString from 'query-string';
import { ProfileWrapper } from 'components/mentoring/styles';
import { showConfirm } from 'components/modal/showConfirm';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import {
  updateMentoringFeedback,
  getMentoringClass,
  mentoringFeedbackCreate,
  getMentoringFeedback,
  mentoringReviewCreate,
  mentoringReviewCreate2,
  getMentoringReview,
  getMentoringReview2
} from 'libs/api/mentoring';
import { useDataApi } from 'libs/hooks';
import { TMentoringFeedback, TMentoringClass, TMentoringReview2 } from 'modules/mentoring';
import { RouteMatch } from 'modules/types';
import { CFeedbackScore } from 'constants/mentoring.const';
import { CUserType, CUserTypeColor } from 'constants/user.const';
import { EUserType, EOperation, ENotificationType } from 'enums/base.enum';
import { EFeedbackScore } from 'enums/mentoring.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Radio, Checkbox, Input, Button, Col, Row, Typography, Form, Spin, Tag } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, FormWrapper, MenteeColor } from 'GlobalStyles';
import { TMentor } from 'modules/user';
import Avatar from 'antd/lib/avatar/avatar';
import Rater from 'react-rater';
import { LikeFilled, LikeOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;
const MentoringReview = () => {
  const mentoringClassId = String(get(queryString.parse(useLocation().search), 'id', ''));
  const mentoringReviewId = String(get(queryString.parse(useLocation().search), 'review_id', ''));
  const match = useRouteMatch(`${ERoute.MentoringReview}/:operation/:record_id?`);
  let { operation = EOperation.View, record_id } = (match?.params as RouteMatch) || {};

  return (
    <>
      {operation === EOperation.Create && (
        <ReviewCreate mentoringClassId={mentoringClassId} isEdit={false} />
      )}
      {operation === EOperation.Edit && (
        <ReviewCreate recordId={record_id} mentoringClassId={mentoringClassId} isEdit={true} />
      )}
      {operation === EOperation.View && <ReviewView mentoringClassId={mentoringClassId} mentoringReviewId={mentoringReviewId} />}
    </>
  );
};

function ReviewScore({ name, disabled }: { name: string; disabled: boolean }) {
  return (
    <Form.Item
      name={name}
      className='form-item no-margin'
      rules={[{ required: true }]}
      style={{ marginBottom: '10px' }}
    >
      <Radio.Group className='col-20p' disabled={disabled}>
        <Radio.Button value={5}>{CFeedbackScore[EFeedbackScore.Excellent]}</Radio.Button>
        <Radio.Button value={4}>{CFeedbackScore[EFeedbackScore.Good]}</Radio.Button>
        <Radio.Button value={3}>{CFeedbackScore[EFeedbackScore.Average]}</Radio.Button>
        <Radio.Button value={2}>{CFeedbackScore[EFeedbackScore.NeedImprovement]}</Radio.Button>
        <Radio.Button value={1}>{CFeedbackScore[EFeedbackScore.Bad]}</Radio.Button>
        <Radio.Button value={0}>{CFeedbackScore[EFeedbackScore.NotApplicable]}</Radio.Button>
      </Radio.Group>
    </Form.Item>
  );
}

//피드백 작성창 - 초기 작성 및 수정 페이지
function ReviewCreate({
  mentoringClassId,
  isEdit,
  recordId,
}: {
  mentoringClassId: string;
  isEdit: boolean;
  recordId?: number;
}) {
  const [{ data: mentoringClass, loading: mentoringClassLoading }] = useDataApi<TMentoringClass>(
    getMentoringClass.bind(null, Number(mentoringClassId)),
  );
  const [form] = Form.useForm();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const history = useHistory();
  const [{ data, loading }] = useDataApi<TMentoringFeedback>(
    getMentoringFeedback.bind(null, Number(recordId)),
    {},
    isEdit,
  );
  const [isChecked, setIsChecked] = useState<boolean>();

  function onClickSubmit() {
    console.log('onClickSubmit ++')
    console.log(form)
    form
      .validateFields()
      .then((value) => {
        //handleSubmit(value as TMentoringFeedback, isCompleted);
        console.log(value)
      })
      .catch((errorInfo) => {
        console.log(errorInfo)
        moveToFirstError(form, errorInfo.errorFields);
      });
  }

  async function handleSubmit(value: TMentoringFeedback, isCompleted: boolean) {
    try {
      setSubmitButtonDisabled(true);
      value.mentoring_class_id = Number(mentoringClassId);
      value.is_completed = isCompleted;
      value.case_tutorial = isChecked === undefined ? false : isChecked;
      if (get(mentoringClass, 'mentor.user.primary_field') === EMentoringField.Consulting) {
        value.overall_score === 0
          ? (value.overall_score = null)
          : (value.overall_score = value.overall_score);
        value.effectiveness_score === 0
          ? (value.effectiveness_score = null)
          : (value.effectiveness_score = value.effectiveness_score);
        value.problemsolving_score === 0
          ? (value.problemsolving_score = null)
          : (value.problemsolving_score = value.problemsolving_score);
        value.communication_score === 0
          ? (value.communication_score = null)
          : (value.communication_score = value.communication_score);
      } else if (get(mentoringClass, 'mentor.user.primary_field') === EMentoringField.Finance) {
        value.analytical_thinking_score === 0
          ? (value.analytical_thinking_score = null)
          : (value.analytical_thinking_score = value.analytical_thinking_score);
        value.motivation_to_develop_score === 0
          ? (value.motivation_to_develop_score = null)
          : (value.motivation_to_develop_score = value.motivation_to_develop_score);
        value.technical_skill_score === 0
          ? (value.technical_skill_score = null)
          : (value.technical_skill_score = value.technical_skill_score);
        value.finance_communication_score === 0
          ? (value.finance_communication_score = null)
          : (value.finance_communication_score = value.finance_communication_score);
      }

      isEdit === true
        ? await updateMentoringFeedback(Number(recordId), value)
        : await mentoringFeedbackCreate(value);

      const message = isCompleted === true ? '피드백이 제출 되었습니다.' : '피드백이 임시 저장 되었습니다.';

      history.push({
        pathname: ERoute.MentoringMyPage,
        state: {
          notification: {
            type: ENotificationType.Success,
            message: message,
          },
        },
      });
    } catch (e) {
      handleFieldError(e, form);
      throw e;
    } finally {
      setSubmitButtonDisabled(false);
    }
  }

  async function handleSubmit2(value: TMentoringReview2) {
    try {
      console.log(value)
      setSubmitButtonDisabled(true);
      
      value.mentoring_class_id = Number(mentoringClassId);
      value.score_contents = ratingContents
      value.score_communication = ratingCommunication
      value.score_professionalism = ratingProfessionlism
      value.score = ratingOverall
      value.tags = []
      if (pointPrep) {
        value.tags.push(1)
      }
      if (pointHiringProcess) {
        value.tags.push(2)
      }
      if (pointResumePrep) {
        value.tags.push(3)
      }
      if (pointFitInterview) {
        value.tags.push(4)
      }
      if (pointMockInterview) {
        value.tags.push(5)
      }
      if (value.comment_extra === undefined) {
        value.comment_extra = ''
      }

      await mentoringReviewCreate2(value);

      const message = '피드백이 제출 되었습니다.';

      history.push({
        pathname: ERoute.MentoringMyPage,
        state: {
          notification: {
            type: ENotificationType.Success,
            message: message,
          },
        },
      });
    } catch (e) {
      handleFieldError(e, form);
      throw e;
    } finally {
      setSubmitButtonDisabled(false);
    }
  }

  useEffect(() => {
    //isEmpty(data) == false => 초기작성페이지가 아닌 임시저장후 수정페이지
    if (isEmpty(data) == false) {
      form.setFieldsValue({
        //consulting
        overall: get(data, 'overall'),
        effectiveness: get(data, 'effectiveness'),
        problemsolving: get(data, 'problemsolving'),
        communication: get(data, 'communication'),
        overall_score: get(data, 'overall_score'),
        effectiveness_score: get(data, 'effectiveness_score'),
        problemsolving_score: get(data, 'problemsolving_score'),
        communication_score: get(data, 'communication_score'),
        //finance
        analytical_thinking: get(data, 'analytical_thinking'),
        motivation_to_develop: get(data, 'motivation_to_develop'),
        technical_skill: get(data, 'technical_skill'),
        finance_communication: get(data, 'finance_communication'),
        analytical_thinking_score: get(data, 'analytical_thinking_score'),
        motivation_to_develop_score: get(data, 'motivation_to_develop_score'),
        technical_skill_score: get(data, 'technical_skill_score'),
        finance_communication_score: get(data, 'finance_communication_score'),
      });
    }
  }, [data]);

  function onCheck(e: any) {
    setIsChecked(e.target.checked);
  }

  useEffect(() => {
    //체크박스 있는 컨설팅 멘토링에서만
    //체크 선택시 점수표 비활성화 및 피드백 섹션 자동 완성
    if (isChecked) {
      form.setFieldsValue({
        //스코어 비활성화 && 멘트 비활성화
        //멘트 세팅은 됐는데 비활성화는 어떻게??
        overall: 'Case tutorial은 mock interview 피드백이 제공되지 않습니다.',
        effectiveness: 'Case tutorial은 mock interview 피드백이 제공되지 않습니다.',
        problemsolving: 'Case tutorial은 mock interview 피드백이 제공되지 않습니다.',
        communication: 'Case tutorial은 mock interview 피드백이 제공되지 않습니다.',
        overall_score: 0,
        effectiveness_score: 0,
        problemsolving_score: 0,
        communication_score: 0,
      });
    } else if (isChecked === false) {
      form.setFieldsValue({
        overall: get(data, 'overall'),
        effectiveness: get(data, 'effectiveness'),
        problemsolving: get(data, 'problemsolving'),
        communication: get(data, 'communication'),
        overall_score: 5,
        effectiveness_score: 5,
        problemsolving_score: 5,
        communication_score: 5,
      });
    }
  }, [isChecked]);

  return (
    <Spin tip='loading...' spinning={loading}>
      <ReviewHeader mentoringClass={mentoringClass} title='멘토링은 어떠셨나요? 피드백을 남겨주세요' />
      <FormWrapper style={{ maxWidth: '800px' }}>
        <Form
          form={form}
          layout='vertical'
          className='form-normal'
          initialValues={{
            tags: []
          }}
        >
          <ReviewForm
            operation={EOperation.Create}
            isChecked={isChecked}
            mentorPrimaryField={get(mentoringClass, 'mentor.user.primary_field')}
          />
          <Form.Item shouldUpdate={true}>
            {() => (
              <Row justify='end'>
                { /*<Button
                  size='large'
                  htmlType='submit'
                  style={{ marginRight: '5px' }}
                  loading={submitButtonDisabled}
                  onClick={onClickSubmit.bind(null, false)}
                  disabled={isChecked}
                >
                  임시 저장
                </Button>*/ }
                <Button
                  type='primary'
                  size='large'
                  htmlType='submit'
                  loading={submitButtonDisabled}
                  onClick={() => {
                    //console.log('onclick +++++')
                    //onClickSubmit
                    //console.log(form)
                    form
                      .validateFields()
                      .then((value) => {
                        //console.log(value)
                        handleSubmit2(value as TMentoringReview2);
                      })
                      .catch((errorInfo) => {
                        moveToFirstError(form, errorInfo.errorFields);
                      });
                      
                    /*showConfirm(
                      onClickSubmit.bind(null, true),
                      <>
                        <div style={{ fontSize: '14px' }}>피드백을 제출하시겠습니까?</div>
                        <div style={{ fontSize: '12px', marginTop: '10px' }}>
                          제출한 뒤에는 수정이 불가능합니다.
                        </div>
                      </>,
                    );*/
                    console.log('onclick -----')
                  }}
                >
                  제출
                </Button>
              </Row>
            )}
          </Form.Item>
        </Form>
      </FormWrapper>
    </Spin>
  );
}
// 피드백 보기 창
function ReviewView({ mentoringClassId, mentoringReviewId }: { mentoringClassId: string, mentoringReviewId: string }) {
  const [{ data: mentoringClass, loading: mentoringClassLoading }] = useDataApi<TMentoringClass>(
    getMentoringClass.bind(null, Number(mentoringClassId)),
  );
  const [{ data, loading }] = useDataApi<TMentoringReview2>(
    getMentoringReview2.bind(null, Number(mentoringReviewId)),
  );
  const [form] = Form.useForm();
  const ReviewViewWrapper = styled.div`
    .ant-input[disabled],
    .ant-radio-button-wrapper-disabled {
      cursor: default;
      color: #000;
    }
    .ant-radio-button-wrapper-checked {
      border: 1px solid ${PrimaryColor} !important;
      background: #fff !important;
      color: ${PrimaryColor} !important;
    }
    .ant-radio-button-wrapper:not(:first-child)::before {
      background-color: transparent;
    }
  `;

  //멘티에게 보여지 피드백/멘토가 작성 완료하고 확인하는 피드백 페이지는 데이터 받아서 setFieldsValue
  useEffect(() => {
    form.setFieldsValue({
      //consulting
      comment: get(data, 'comment'),
      comment_extra: get(data, 'comment_extra'),
    });
  }, [data]);

  return (
    <ReviewViewWrapper>
      <Spin tip='loading...' spinning={loading}>
        <ReviewHeader mentoringClass={mentoringClass} title='멘토링은 어떠셨나요? 피드백을 남겨주세요' />
        <FormWrapper style={{ maxWidth: '800px' }}>
          <Form form={form} layout='vertical' className='form-normal'>
            <ReviewForm
              operation={EOperation.View}
              mentorPrimaryField={get(mentoringClass, 'mentor.mentoring_field')}
              reviewToView={data}
            />
          </Form>
        </FormWrapper>
      </Spin>
    </ReviewViewWrapper>
  );
}

var ratingContents = 5
var ratingCommunication = 5
var ratingProfessionlism = 5
var ratingOverall = 5
var pointPrep = false
var pointHiringProcess = false
var pointResumePrep = false
var pointFitInterview = false
var pointMockInterview = false
//피드백 form
function ReviewForm({
  operation,
  isChecked,
  mentorPrimaryField,
  reviewToView
}: {
  operation: EOperation;
  isChecked?: boolean;
  mentorPrimaryField?: string;
  reviewToView?: TMentoringReview2
}) {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [disabled, setDisabled] = useState<boolean>(operation === EOperation.View);
  useEffect(() => {
    if (operation === EOperation.View) {
      //피드백 보기 페이지일 때
      setDisabled(true);

      if (reviewToView !== undefined) {
        handleRate(reviewToView.score_contents, 'contents')
        handleRate(reviewToView.score_communication, 'communication')
        handleRate(reviewToView.score_professionalism, 'professionalism')

        for (let index = 0; index < reviewToView.tags.length; index++) {
          const t = reviewToView.tags[index];
          switch (t) {
            case 1:
              handlePointOnClick('pointPrep')
              break;
            case 2:
              handlePointOnClick('pointHiringProcess')
            break;
            case 3:
              handlePointOnClick('pointResumePrep')
              break;
            case 4:
              handlePointOnClick('pointFitInterview')
              break;
            case 5:
              handlePointOnClick('pointMockInterview')
              break;
            default:
              break;
          }
        }
      }
    } else if (operation === EOperation.Create && isChecked === true) {
      //피드백 작성 && Case tutorial 멘토링 체크되었을 때
      setDisabled(true);  
    } else {
      //위의 상황이 아니면 스코어 버튼 활성화 EOperation.Edit 이나 EOperation.Create 일 때
      setDisabled(false);
    }
  }, [isChecked]);

  const [pointPrepValue, setPointPrepValue] = useState(false);
  const [pointHiringProcessValue, setHiringProcessValue] = useState(false);
  const [pointResumePrepValue, setResumePrepValue] = useState(false);
  const [pointFitInterviewValue, setFitInterviewValue] = useState(false);
  const [pointMockInterviewValue, setMockInterviewValue] = useState(false);
  function handlePointOnClick(type: string) {
    switch (type) {
      case 'pointPrep':
        setPointPrepValue(!pointPrepValue);
        pointPrep = !pointPrepValue
        break;
      case 'pointHiringProcess':
        setHiringProcessValue(!pointHiringProcessValue);
        pointHiringProcess = !pointHiringProcessValue
        break;
      case 'pointResumePrep':
        setResumePrepValue(!pointResumePrepValue);
        pointResumePrep = !pointResumePrepValue
        break;
      case 'pointFitInterview':
        setFitInterviewValue(!pointFitInterviewValue);
        pointFitInterview = !pointFitInterviewValue
        break;
      case 'pointMockInterview':
        setMockInterviewValue(!pointMockInterviewValue);
        pointMockInterview = !pointMockInterviewValue
        break;
    }
  }

  const [ratingContentsValue, setRatingContentsValue] = useState(5);
  const [ratingCommunicationValue, setRatingCommunicationValue] = useState(5);
  const [ratingProfessionlismValue, setRatingProfessionlismValue] = useState(5);
  const [ratingOverallValue, setRatingOverallValue] = useState(5);

  const [commentContents, setCommentContents] = useState(<div style={{ color: '#aeaeae' }}>5점. 최고에요</div>);
  const [commentCommunication, setCommentCommunication] = useState(<div style={{ color: '#aeaeae' }}>5점. 최고에요</div>);
  const [commentProfessionlism, setCommentProfessionlism] = useState(<div style={{ color: '#aeaeae' }}>5점. 최고에요</div>);
  const [commentOverall, setCommentOverall] = useState(<div style={{ color: '#aeaeae' }}>5점. 최고에요</div>);
  function handleRate(rating: number, type: string ) {
    switch (type) {
      case 'contents':
        setRatingContentsValue(rating);
        switch (rating) {
          case 1:
            setCommentContents(<div style={{ color: '#ffce50' }}>1점. 별로에요</div>);
            break;
          case 2:
            setCommentContents(<div style={{ color: '#ffce50' }}>2점. 그저그래요</div>);
            break;
          case 3:
            setCommentContents(<div style={{ color: '#ffce50' }}>3점. 괜찮아요</div>);
            break;
          case 4:
            setCommentContents(<div style={{ color: '#ffce50' }}>4점. 좋아요</div>);
            break;
          case 5:
            setCommentContents(<div style={{ color: '#ffce50' }}>5점. 최고에요</div>);
            break;
        }
        ratingContents = rating
        break;
      case 'communication':
        setRatingCommunicationValue(rating);
        switch (rating) {
          case 1:
            setCommentCommunication(<div style={{ color: '#ffce50' }}>1점. 별로에요</div>);
            break;
          case 2:
            setCommentCommunication(<div style={{ color: '#ffce50' }}>2점. 그저그래요</div>);
            break;
          case 3:
            setCommentCommunication(<div style={{ color: '#ffce50' }}>3점. 괜찮아요</div>);
            break;
          case 4:
            setCommentCommunication(<div style={{ color: '#ffce50' }}>4점. 좋아요</div>);
            break;
          case 5:
            setCommentCommunication(<div style={{ color: '#ffce50' }}>5점. 최고에요</div>);
            break;
        }
        ratingCommunication = rating
        break;
      case 'professionalism':
        setRatingProfessionlismValue(rating);
        switch (rating) {
          case 1:
            setCommentProfessionlism(<div style={{ color: '#ffce50' }}>1점. 별로에요</div>);
            break;
          case 2:
            setCommentProfessionlism(<div style={{ color: '#ffce50' }}>2점. 그저그래요</div>);
            break;
          case 3:
            setCommentProfessionlism(<div style={{ color: '#ffce50' }}>3점. 괜찮아요</div>);
            break;
          case 4:
            setCommentProfessionlism(<div style={{ color: '#ffce50' }}>4점. 좋아요</div>);
            break;
          case 5:
            setCommentProfessionlism(<div style={{ color: '#ffce50' }}>5점. 최고에요</div>);
            break;
        }
        ratingProfessionlism = rating
        break;
    }

    //console.log(`ratingContents = ${ratingContents}, ratingCommunication = ${ratingCommunication}, ratingProfessionlism = ${ratingProfessionlism}`)
    ratingOverall = ((ratingContents + ratingCommunication + ratingProfessionlism) / 3 | 0);
    setRatingOverallValue(ratingOverall);
    switch (ratingOverall) {
      case 1:
        setCommentOverall(<div style={{ color: '#ffce50' }}>1점. 별로에요</div>);
        break;
      case 2:
        setCommentOverall(<div style={{ color: '#ffce50' }}>2점. 그저그래요</div>);
        break;
      case 3:
        setCommentOverall(<div style={{ color: '#ffce50' }}>3점. 괜찮아요</div>);
        break;
      case 4:
        setCommentOverall(<div style={{ color: '#ffce50' }}>4점. 좋아요</div>);
        break;
      case 5:
        setCommentOverall(<div style={{ color: '#ffce50' }}>5점. 최고에요</div>);
        break;
    }
  }

  return (
    <>
      {mentorPrimaryField === EMentoringField.Consulting && (
        <>
          <Title level={3}>멘토링 후 좋았던 점에 대해 리뷰를 남겨주세요</Title>
          <Form.Item name='comment' className='form-item' rules={[{ required: true }]}>
            <Input.TextArea
              className='form_textarea'
              placeholder='최소 10자 이상 입력해 주세요.'
              autoSize={{ minRows: 8 }}
              disabled={disabled}
              minLength={10}
            />
          </Form.Item>
          <div style={{ fontSize: '14px' }}>멘토님이 볼 수 있는 영역은 위 리뷰 부분이며, 익명성 보장을 위해 프로필 사진, 닉네임/이름, 멘토링 진행 시점 등 모든 정보는 익명처리 됩니다. 또, 멘토님이 후기를 특정할 수 없도록 일정량의 후기가 쌓이기 전까지 보이지 않으며 후기 순서도 랜덤으로 보여집니다.</div>
          <br />
          <div style={{ fontSize: '14px' }}>아래 3가지 항목의 별점이 합산된 후 평균 점수가 멘토의 평점으로, 다른 멘티분들도 점수를 확인할 수 있습니다. 멘토님에겐 후기가 보이지 않으니 편하게 작성해 주세요.</div>
          <br /><br />

          <Title level={3}>Contents</Title>
          <div className='rater-interactive'>
            <Rater key='contents' interactive={!disabled} rating={ratingContentsValue} onRate={(event) => handleRate(event.rating, 'contents')} />
              {commentContents}
          </div>
          <br />
          <div style={{ fontSize: '14px' }}>멘토링 진행방식, 내용 그리고 퀄리티에 얼마나 만족하시나요?</div>
          <br /><br />

          <Title level={3}>Communication</Title>
          <div className='rater-interactive'>
            <Rater key='communication' interactive={!disabled} rating={ratingCommunicationValue} onRate={(event) => handleRate(event.rating, 'communication')} />
              {commentCommunication}
          </div>
          <br />
          <div style={{ fontSize: '14px' }}>멘토링 내용 전달에 얼마나 만족하시나요?</div>
          <br /><br />

          <Title level={3}>Professionalism</Title>
          <div className='rater-interactive'>
            <Rater interactive={!disabled} rating={ratingProfessionlismValue} onRate={(event) => handleRate(event.rating, 'professionalism')} />
              {commentProfessionlism}
          </div>
          <br />
          <div style={{ fontSize: '14px' }}>멘토님의 준비성, 가르치려는 열의, 시간 약속 등에 얼마나 만족하시나요?</div>
          <br /><br />

          <Title level={3}>Overall</Title>
          <div className='rater-interactive'>
            <Rater interactive={false} rating={ratingOverallValue} />
          </div>
          <br />
          { ratingOverall < 4 ? <Form.Item name='comment_extra' className='form-item' rules={[{ required: false }]}>
            <Input.TextArea
              className='form_textarea'
              placeholder='어떤 부분이 마음에 안들었나요? 멘토님은 해당 글을 확인하실 수 없고, 서비스 개선을 위한 용도로만 사용되니 편하게 작성해주세요.'
              autoSize={{ minRows: 8 }}
              disabled={disabled}
            />
          </Form.Item> : <div></div>}
          <br /><br />

          <Title level={3}>멘토의 추천 포인트가 있다면 선택해주세요</Title>
          <div style={{ fontSize: '14px' }}>선택 사항이며 중복으로 선택이 가능합니다.</div>
          <Row justify='start'>
            <Button
            size={pointPrepValue ? 'large' : 'small'}
            htmlType='button'
            style={{ marginRight: '5px' }}
            icon={pointPrepValue ? <LikeFilled /> : <LikeOutlined />}
            onClick={disabled ? () => {} : handlePointOnClick.bind(null, 'pointPrep')}
            >
              준비 방법
            </Button>
            <Button
            size={pointHiringProcessValue ? 'large' : 'small'}
            htmlType='button'
            style={{ marginRight: '5px' }}
            icon={pointHiringProcessValue ? <LikeFilled /> : <LikeOutlined />}
            onClick={disabled ? () => {} : handlePointOnClick.bind(null, 'pointHiringProcess')}
            >
              채용 프로세스
            </Button>
            <Button
            size={pointResumePrepValue ? 'large' : 'small'}
            htmlType='button'
            style={{ marginRight: '5px' }}
            icon={pointResumePrepValue ? <LikeFilled /> : <LikeOutlined />}
            onClick={disabled ? () => {} : handlePointOnClick.bind(null, 'pointResumePrep')}
            >
              Resume 첨삭
            </Button>
            <Button
            size={pointFitInterviewValue ? 'large' : 'small'}
            htmlType='button'
            style={{ marginRight: '5px' }}
            icon={pointFitInterviewValue ? <LikeFilled /> : <LikeOutlined />}
            onClick={disabled ? () => {} : handlePointOnClick.bind(null, 'pointFitInterview')}
            >
              Fit 인터뷰 준비
            </Button>
            <Button
            size={pointMockInterviewValue ? 'large' : 'small'}
            htmlType='button'
            style={{ marginRight: '5px' }}
            icon={pointMockInterviewValue ? <LikeFilled /> : <LikeOutlined />}
            onClick={disabled ? () => {} : handlePointOnClick.bind(null, 'pointMockInterview')}
            >
              Mock 인터뷰
            </Button>
          </Row>
          <br /><br />
        </>
      )}
    </>
  );
}

function ReviewHeader({ mentoringClass, title }: { mentoringClass: TMentoringClass; title: string }) {
  return (
    <div style={{ textAlign: 'center', paddingTop: '40px' }}>
      <Title level={2}>{title}</Title>
      <ProfileWrapper style={{ marginLeft: '20px' }}>
        <div className='border-box'>
          <Row justify='center' gutter={[8, 8]}>
            <Col flex='100px'>
              <Avatar
                style={{ borderRadius: '50%', width: '100%', height: 'auto' }}
                src={get(mentoringClass, 'mentor.user.profile_image.absolute_url')}
              />
            </Col>
            <Col flex='200px'>
                <div className='name'>{get(mentoringClass, 'mentor.user.fullname')}</div>
                <div className='intro'>"{get(mentoringClass, 'mentor.short_introduction')}"</div>
                <div style={{ lineHeight: '30px' }}>
                  { /*<Rater interactive={false} rating={get(mentor, 'score_average')} />*/ }
                  <span style={{ marginLeft: '5px' }} className='score'>
                    {get(mentoringClass, 'mentor.score_average')}
                  </span>
                  <span className='num-of-rater'>&nbsp;({get(mentoringClass, 'mentor.num_of_rater', 0)})</span>
                </div>
            </Col>
          </Row>
        </div>
      </ProfileWrapper>
    </div>
  );
}

export default MentoringReview;
